import { AUTHORITIES } from 'app/config/constants';
import PrivateRoute from 'app/shared/auth/private-route';
import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import React from 'react';
import { Switch } from 'react-router-dom';
import TruckImplementInfo from '../../modules/dashboards/dashboard-truck-implement/components/truck-implement-info-tab/TruckImplementInfo';
import TruckImplementCard from './truck-implement-card';
import TruckImplemenDeleteDialog from './truck-implement-delete-dialog';
import { TruckImplementUpdate } from './truck-implement-update';

const Routes = ({ match }) => (
  <>
    <Switch>
      <PrivateRoute
        exact
        path={`${match.url}/new`}
        component={TruckImplementUpdate}
        hasAnyAuthorities={[AUTHORITIES.ADMIN, AUTHORITIES.REPRESENTATIVE_ADMIN]}
      />
      <PrivateRoute
        path={`${match.url}/:id/delete`}
        component={TruckImplemenDeleteDialog}
        hasAnyAuthorities={[AUTHORITIES.ADMIN, AUTHORITIES.REPRESENTATIVE_ADMIN]}
      />
      <PrivateRoute
        path={`${match.url}/:id/edit`}
        component={TruckImplementUpdate}
        hasAnyAuthorities={[AUTHORITIES.ADMIN, AUTHORITIES.REPRESENTATIVE_ADMIN, AUTHORITIES.TRANSPORTER_ADMIN]}
      />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={TruckImplementInfo} />
      <ErrorBoundaryRoute path={`${match.url}`} component={TruckImplementCard} />
    </Switch>
  </>
);

export default Routes;
